import App from './App.svelte';

// noinspection JSValidateTypes
const app = new App({
    target: document.body
});

// noinspection JSUnusedGlobalSymbols
export default app;